import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import Input from "components/FormComponents/ControlledInput";
import CheckBox from "components/FormComponents/ControlledCheckbox";
import clsx from "clsx";
import * as yup from "yup";
import { reportError } from "crashlytics";

import styles from "./index.module.css";

import { writeToStorage, readFromStorage } from "../../utils/storage";
import { QueryKeys, RomanianMonths } from "common/constants";
import { useReserveUpdate } from "queries/service";

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
};

const Step1 = () => {
    const history = useHistory();
    const [checkboxValue, setCheckboxValue] = useState(false);

    //----------start data---------------//
    const departmentName = readFromStorage(QueryKeys.department);
    const serviceName = readFromStorage(QueryKeys.service);
    const date = readFromStorage(QueryKeys.date);
    const time = readFromStorage(QueryKeys.time);
    const personalData = readFromStorage(QueryKeys.personalData);
    const additionalData = readFromStorage(QueryKeys.additionalData);

    console.log("Date Log :" + new Date(date))


    let query = useQuery();
    const appointmentId = query.get("appointment_id");

    const defaultValues = {
        client_name: personalData?.client_name || "",
        appointment_id: appointmentId || "",
        client_phone: personalData?.client_phone || "",
        client_email_address: personalData?.client_email_address || "",
        client_agree: personalData?.client_agree || null,
        client_cnp: personalData?.client_cnp || ""
    };

    const schema = yup.object({
        client_name: yup.string(),
        client_cnp: yup.string(),
        client_phone: yup.string().matches(/^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/),
        // client_email_address: yup.string().email(),
        client_agree: yup.boolean().oneOf([true]),
    }).required();

    const formMethods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(schema)
    });

    const { control, handleSubmit, watch, setValue, errors, formState } = formMethods;

    const {
        mutateAsync: reserveUpdate,
    } = useReserveUpdate();

    const onSubmit = async (data) => {
        if (!appointmentId) return;

        writeToStorage(QueryKeys.personalData, {
            appointment_id: appointmentId,
            client_name: data?.client_name,
            client_cnp: data?.client_cnp,
            client_phone: data?.client_phone.toString(),
            client_email_address: data?.client_email_address,
            client_agree: data?.client_agree,
        });
        try {
            const result = await reserveUpdate({
                appointment_id: appointmentId,
                client_name: data?.client_name,
                client_phone: data?.client_phone.toString(),
                client_email_address: data?.client_email_address,
                client_cnp: data?.client_cnp,
                client_additional: additionalData
            });
            if (result?.success) {
                history.push("/programare/step8")
            }
        } catch (error) {
            reportError("Step7: onSubmit: error:", error);
        }
    };
    //----------end data---------------//

    useEffect(() => {
        setCheckboxValue(personalData?.client_agree || null)
    }, []);

    return (
        <div className={styles.step7Page}>
            <div className={styles.pageHeader}>
                <Text type={"h3"}>Pasul 4 din 5</Text>
                <Text type={"h1"}>
                    {departmentName} / {serviceName}
                </Text>
            </div>
            {date &&
                <Paper className={styles.paper}>
                    <Text type={"h3"}>
                        Data: {new Date(date).getDate()}  {RomanianMonths[new Date(date).toLocaleString('default', { month: 'long' })]} {new Date(date).getFullYear()} Ora: {time}
                    </Text>
                </Paper>
            }
            <Paper className={styles.paper}>
                <Text type={"h1"}>Date personale</Text>
                <Text type={"h3"}>
                    Pentru a confirma această programare, te rugăm să introduci datele
                    tale complete:
                </Text>
                <FormProvider {...formMethods}>
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Input
                            className="mb-12"
                            name="client_name"
                            label="Nume și prenume *"
                            defaultValue={personalData?.client_name}
                        />
                        <Input
                            className="mb-12"
                            name="client_cnp"
                            label="Cod numeric personal (CNP) *"
                            defaultValue=""
                        />
                        <Input
                            className="mb-12"
                            name="client_phone"
                            label="Număr de telefon mobil *"
                            defaultValue=""
                        />
                        <Input
                            className="mb-12"
                            name="client_email_address"
                            label="Adresă de email"
                            defaultValue=""
                        />
                        <div className="mb-26">
                            <CheckBox
                                name="client_agree"
                                label="Obligatoriu: Sunt de acord cu procesarea datelor mele personale"
                                checked={checkboxValue}
                                onClick={(e) => setCheckboxValue(e.target.checked)}
                            />
                        </div>
                        <div
                            className={clsx(
                                styles.actionContainer,
                                styles.alignCenter,
                                styles.spaceBtw
                            )}
                        >
                            <Button
                                className={styles.prevButton}
                                size="large"
                                variant="secondary"
                                label="<- înapoi"
                                onClick={history.goBack}
                            />
                            <Button
                                className={styles.nextButton}
                                size="large"
                                label="Continuă ->"
                                type="submit"
                                disabled={!formState.isValid}
                            />
                        </div>
                    </form>
                </FormProvider>
            </Paper>
            <Paper className={styles.paper}>
                <Text type={"h3"}>
                    Dacă nu ai acces la un telefon mobil, sună la 021.9441 pentru a te
                    programa prin telefon.
                </Text>
            </Paper>
        </div>
    );
};

export default Step1;
